import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
import { EntryShared } from '../EntryShared.ts';
export function sendMobileScenePageVisitAnalytic(scene) {
    if (scene == UIMSceneEnum.Game) return;
    let pathName;
    switch(scene){
        case UIMSceneEnum.Leaderboard:
            pathName = '/leaderboards';
            break;
        case UIMSceneEnum.Lobby:
            pathName = '/lobby';
            break;
        case UIMSceneEnum.Homepage:
            pathName = '/';
            break;
        case UIMSceneEnum.Store:
            pathName = '/store';
            break;
        case UIMSceneEnum.More:
            pathName = '/more';
            break;
    }
    EntryShared.sendPageVisitAnalyticEvent(pathName);
}
